import '../styles/Footer.css';
import DevBy from './DevelopedBy';

function Footer({ showIntro = true }) {
    return (
        <footer className="footer-section" id="footer">
            <div className="footer-shell">
                {showIntro && (
                    <div className="footer-info">
                        <h3>Redo för en skinande vardag?</h3>
                        <div className="footer-cta-row">
                            <a className="footer-cta ghost" href="/kontakt">Boka konsultation</a>
                        </div>
                    </div>
                )}

                <div className="footer-details" aria-label="Kontaktuppgifter">
                    <div>
                        <span className="footer-label">Telefon</span>
                        <a className="footer-link" href="tel:+46723227586">072 322 75 86</a>
                        <p className="footer-text">Vardagar 12:00-17:00</p>
                    </div>
                    <div>
                        <span className="footer-label">E-post</span>
                        <a className="footer-link" href="mailto:jasnakuleja@gmail.com">jasnakuleja@gmail.com</a>
                    </div>
                </div>
            </div>

            <DevBy />
        </footer>
    );
}

export default Footer;
